// Mirrors the backend's rules (service.service.ts / servicePriceRules.util.ts)
// — these catalog names have a fixed or ranged price enforced server-side;
// this just drives the admin UI's hints/validation before submit.
export const SERVICE_PRICE_RULES = {
  inspection: { min: 99, max: 199, lockedPriceForProvider: 149 },
  survey: { min: 99, max: 199, lockedPriceForProvider: 149 },
  'inspection/survey': { min: 99, max: 199, lockedPriceForProvider: 149 },
  'mini services': { min: 299, max: 499 },
  'full day': { min: 899, max: 1299 },
  'full day with a helper': { min: 1899, max: 2199 },
};

export const getServicePriceRule = (name) =>
  name ? SERVICE_PRICE_RULES[name.trim().toLowerCase()] : undefined;
